<template>
    <modal :isLoading="isLoading" @close="closeModal">
        <h1 class="modal__title">
            <small>{{ trans('services.add-dns-title') }}</small>
        </h1>

        <form class="u-margin-bottom-narrow" @submit.prevent="addDns">
            <text-input
                v-model="form.domain"
                :error="form.errors.first('subscriptions.dns.0.domain')"
                :label="trans('services.domain')"
                name="domain"
                class="u-full-width"
                required
            />

            <div class="modal__nav">
                <button
                    class="btn btn--ghost-gray btn-ghost--dns | u-margin-right"
                    type="button"
                    :disabled="isLoading"
                    @click="closeModal"
                >
                    {{ trans('action.cancel') }}
                </button>
                <button
                    class="btn btn--blue-record btn-ghost--dns"
                    dusk="confirm-button"
                    type="submit"
                    :disabled="isLoading"
                >
                    {{ trans('action.add') }}
                </button>
            </div>
        </form>
    </modal>
</template>

<script>
import { Modal } from 'relapp-modal';

export default {
    components: {
        Modal
    },
    props: {
        form: {
            type: Object,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: true
        }
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },
        /**
         * Submit the modal.
         */
        addDns() {
            this.$emit('submit', this.form);
        }
    }
};
</script>
